import React, { useEffect, useMemo, useState } from 'react';
import { FaSearch } from 'react-icons/fa';  // Import the search icon
import "../App.css"
import "../css/user.css"
import axios from 'axios';  // Import axios
import Footer from '../components/Footer';
import { API_URL_All } from '../api';
import ClientLayout from '../components/ClientLayout';
import { CheckingTicket, LockingTicket, ClockIcon, EyeIcon } from '../components/tickets/Tickets';
import * as general from '../libs/general';
import { useLocation } from 'react-router-dom';
import OrderCommentModal from '../components/orders/OrderCommentModal';

function OrderSearch() {
  const [orderCode, setOrderCode] = useState('');  // State to store order code input
  const [status, setStatus] = useState('');  // Default status
  const [loading, setLoading] = useState(false); // To show loading status
  const [showStatus, setShowStatus] = useState(false);  // State to control the display of the status text
  const [model, setModel] = useState({});
  
  const location = useLocation();

  const {orderData, message, searchRefer} = location.state || {};
  const searchedCode = useMemo(() => {
    if (searchRefer && String(searchRefer).trim()) return String(searchRefer).trim();
    if (orderData?.order?.name) return orderData.order.name;
    return '';
  }, [searchRefer, orderData]);

  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     handleSearch();
  //   }
  // };

  // const handleSearch = async () => {
  //   // Make the API request with the shipping code entered by the user
  //   if (!orderCode) {
  //     setStatus('Vui lòng nhập mã vận đơn!');
  //     setShowStatus(true);
  //     return;
  //   }

  //   setLoading(true);  // Set loading to true while making the API call
  //   setShowStatus(true);  // Show the status text after clicking the button
  //   setStatus("");
  //   setModel({});
  //   try {
  //     //const response = await axios.get(`${API_URL_All}/api/import-orders/status?shippingCode=${orderCode}`);
  //     const response = await axios.get(`${API_URL_All}/api/clients/findOrderLogs?refer=${orderCode}`);
  //     var obj = response.data;
  //     setModel(obj);
  //     if(obj.success === false){
  //       setStatus(obj.message);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching order status:', error);
  //     setStatus('Lỗi khi tìm kiếm trạng thái');
  //   } finally {
  //     setLoading(false);  // Stop loading when the request is finished
  //   }
  // };
  // useEffect(() => {
  //   if (orderCode === '') {
  //     setShowStatus(false);
  //   }
  // }, [orderCode]);


  useEffect(() => {
    if (orderData) {
      setModel({ data: orderData, success: true });
      // setShowStatus(true);
      setStatus('');
    }else if (message) {
      setModel({});
      setStatus(message);
    }
  }, [orderData, message]);

  return (
    <div>
      <ClientLayout>
        <div className="table-responsive web-table">
          <div className="container-fluid">
            {/* <div className="row bg-zto">
              <div className='col-6 col-md-2 pt-1 pb-1 fw-bold text-white text-uppercase d-flex align-items-center'>
                Tra cứu đơn hàng
              </div>
              <div className='col-6 col-md-6 pt-1 pb-1'>
                <div className="input-group search-block">
                  <input
                    type="text"
                    id="orderCode"
                    className="form-control form-control-sm"
                    placeholder="Nhập mã vận đơn"
                    value={orderCode}
                    onChange={(e) => setOrderCode(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <button className="btn btn-light btn-sm" type="button" title="Tìm kiếm" disabled={loading} onClick={handleSearch}>
                    {loading ? 'Đang tìm kiếm...' : <FaSearch />}
                  </button>
                </div>
              </div>
            </div> */}

            {model.data && model.data.order && model.data.order.id && (
              <div className="container">

                <div className="row">
                  <div className="col-md-12 m-3">
                    <div>
                      {searchedCode && (
                        <div className="row">
                          <div className="col-md-12 mt-3">
                            <span className="text-dark">
                              Đơn hàng: {searchedCode}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    {model.data &&
                      model.data.items.map((item, index) => (
                        <div
                          className="history-item"
                          data-progress-index={index}
                          key={index}
                        >
                          <div className="progress-name">
                            {item.progressName}
                          </div>
                          <div className="progress-time">
                            <ClockIcon />{" "}
                            <span>
                              {general.formatDateTime2(item.createdAt)}
                            </span>{" "}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="row">
                  <OrderCommentModal
                    orderId={model.data.order.id}
                    refer={searchRefer}
                    isPublic={true}
                  />
                </div>
              </div>
            )}
            <div className="row">
              {status && (
                <div className="col-md-12  text-center pt-3">
                  <p className="fw-bold fs-2 text-success">{status}</p>
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </ClientLayout>
    </div>
  );
}

export default OrderSearch;
